/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/26/19
 * Time: 10:47 AM
 */
import React, {Component} from 'react';
import './Validation_MobEmail.css'
import {Button as SementicBtn, Dropdown, Input, Message} from 'semantic-ui-react'
import Modal from "../../../../components/Modal/Modal";
import {Col, Row} from "reactstrap";
import * as common from "../../../../const/Common/CommonFunc";
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import Cookies from "js-cookie";
import axios from "../../../../axios/axios_visitortag";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import apiConfig from "../../../../axios/axios_api_services";

class App extends Component {
  state = {
    type: "",
    list: [],
    options: [],
    value: ""
  };
  onChangeType = (e, {value}) => {
    this.setState({
      type: value
    })
  };
  fillData = () => {
    let data = this.props.data;
    let list = [];
    let options = [];

    if(data !== null && data.visitor !== undefined){
      if (data.visitor.mobile !== null && data.visitor.mobile !== undefined) {
        options.push({key: 1, text: 'Mobile', value: 'MOBILE'})
        list.push("Mobile: " + data.visitor.mobile)
      }
      if (data.visitor.email !== null && data.visitor.email !== undefined) {
        options.push({key: 2, text: 'Email', value: 'EMAIL'});
        list.push("Email: " + data.visitor.email)
      }
    }

    this.setState({
      list: list,
      options: options,
      type: options.length !== 0 ? options[0].value : "INVALID"
    });
  };
  checkValidation = () => {
    let type = this.state.type;
    let value = this.state.value.trim();

    if (value !== "") {
      let obj = {
        userId: this.props.data.visitor.userId,
        value: value,
        type: type
      };
      this.sendToBackend(obj)
    } else {
      common.notifyMessage("Please enter value")
    }
  };
  sendToBackend = (obj) => {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);

    axios.post(apiConfig.CORPORATE_VISITOR_VERIFY, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Visitor successfully identified - (" + obj.value + ")", 0);

          this.props.closeModal("visitBefore", true);
          this.props.sendData(response.data.visitorDetailsDTO);

        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend(obj)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };
  handleChange = name => event => {
    let value = event.target.value;
    this.setState({
      [name]: value
    })
  };
  toggle = () => {
  };

  componentDidMount() {
    this.fillData();
  }

  render() {
    return (

      <MDBModal isOpen={true} toggle={this.toggle} size="md">
        <MDBModalHeader toggle={() => this.props.closeModal("visitBefore", true)}>Please verify user mobile or email</MDBModalHeader>
        <MDBModalBody>

          <Col xs="12" lg={"12"} md={"12"} className={"padd_grap"}>
            {
              this.state.list.length !== 0 ?
                <Row>
                  <Col lg={12}>

                    <Message
                      warning
                      // header=''
                      list={this.state.list}
                    />

                    <Input
                      style={{width: '100%'}}
                      action={<Dropdown style={{width: 'auto!important'}} onChange={this.onChangeType} button basic floating
                                        options={this.state.options}
                                        value={this.state.type} className={"end-"}/>}
                      icon={this.state.type === "MOBILE" ? 'mobile' : this.state.type === "EMAIL" ? 'envelope' : ''}
                      iconPosition='left'
                      placeholder='Enter value'
                      onChange={this.handleChange("value")}
                    />
                  </Col>
                  <br/>
                  <Col lg={12} className={"check-validation-col"}>
                    {
                      this.state.list.length !== 0 ?
                        <SementicBtn className="px-5" onClick={this.checkValidation}>Proceed</SementicBtn> : null
                    }

                  </Col>
                </Row>:
                <Row>
                  <Col lg={12}>
                    <Message
                      error
                      header="Can't reveal information of this user."                    />
                  </Col>
                </Row>
            }

          </Col>

        </MDBModalBody>
      </MDBModal>
    );
  }
}

const mapStateToProps = (state) => ({
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
